export default "__VITE_ASSET__C$GuRvL0__"